import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import TextInput from "../../common/component/form/TextInput";
import trainingApi from '../api/trainingApi';
import {command} from '../../common/util/DispatchUtil';
import {useDispatch, useSelector} from 'react-redux';
import AccountRoles from '../../account/enums/AccountRoles';

function SharePopup({
                        trainingId
                    }) {

    const [t] = useTranslation();
    const dispatch = useDispatch();
    const role = useSelector(state => state.account.role);
    const [buttonText, setButtonText] = useState('Training.COPY_SHARE_LINK');
    const trainingShareToken = useSelector(state => state.training.shareToken);
    const [maxNumberOfLinksReached, setMaxNumberOfLinksReached] = useState(false);

    useEffect(() => {
        loadTrainingShareToken();
    }, []);

    function loadTrainingShareToken() {
        if (trainingId) {
            trainingApi.getShareTokenForTraining(trainingId).then(tokenResponse => {
                if (tokenResponse.data.success) {
                    if (tokenResponse.data.result.maxNumberOfLinksReached) {
                        setMaxNumberOfLinksReached(true);
                    } else {
                        setMaxNumberOfLinksReached(false);
                        dispatch(command('SET_TRAINING_SHARE_TOKEN', tokenResponse.data.result?.value));
                    }
                }
            });
        }

    }

    function getCurrentUrlBaseLink() {
        return window.location.href.substring(0, window.location.href.lastIndexOf('/')).replace('training', 'training/shared');
    }

    const link = `${getCurrentUrlBaseLink()}/${trainingShareToken}`;

    let maxLinksReachedText = t('Training.FREE_LINK_LIMIT_REACHED');
    if (role === AccountRoles.ADMINISTRATOR) {
        maxLinksReachedText = t('Training.FREE_LINK_LIMIT_REACHED_ADMIN');
    }

    return (
        <>
            {
                <div className="share-overlay">
                    <p><b>{t('Training.SHARE_LINK_TITLE')}</b></p>
                    {
                        maxNumberOfLinksReached ?
                            <div>{maxLinksReachedText}</div>
                            :
                            <>
                                <TextInput
                                    id="link"
                                    value={link}
                                    type="text"
                                />
                                <button
                                    className="btn btn-primary"
                                    id="btn-copy-share-link-to-clipboard"
                                    onClick={() => {
                                        navigator.clipboard.writeText(link);
                                        setButtonText('Training.LINK_COPIED');
                                    }
                                    }
                                >
                                    {t(buttonText)}
                                </button>
                                <p>{t('Training.SHARE_DESCRIPTION')}</p>
                            </>
                    }
                </div>

            }

        </>
    );
}

export default SharePopup;
